<div class="p-6">
    <h1 class="text-xl font-semibold mb-2">Échec de connexion</h1>
    <p class="mb-4">La tentative d'authentification a échoué. Veuillez réessayer.</p>
    <a class="underline" href="/">Revenir à l’accueil</a>
</div>
